import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=85e18fe4"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85e18fe4')) {
      api.createRecord('85e18fe4', component.options)
    } else {
      api.reload('85e18fe4', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=85e18fe4", function () {
      api.rerender('85e18fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TaskList.vue"
export default component.exports